import AuthLegalDisclosure from './AuthLegalDisclosure';

export default AuthLegalDisclosure;
